<template>
  <b-modal
    id="modal-danger"
    ref="confirm"
    v-model="isVisible"
    v-bind="$attrs"
    :ok-variant="variant"
    ok-title="Accept"
    modal-class="modal-normal"
    centered
    v-on="{ ...$listeners }">
    <div class="d-block text-center mb-1">
      <p class="font-weight-bold h2">
        {{ title }}
      </p>
    </div>
    <div
      class="mx-auto mb-2"
    >
      <TextAreaInput
        v-model="remarkValue"
        :rules="{ required: false }"
        name="Remark"
        label="Remark"
        placeholder="Input Remark"
        trim />
    </div>
    <template #modal-footer="{ hide }">
      <div class="mx-auto">
        <b-button
          :variant="variant"
          style="margin-right: 12px"
          @click="_confirm()">
          Re Open
        </b-button>
        <b-button
          variant="outline-primary"
          @click="hide">
          Cancel
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import TextAreaInput from '@/components/Form/TextAreaInput.vue'

export default {
  components: {
    TextAreaInput
  },
  props: {
    remark: {
      type: String,
      default: ''
    }
    // variant: {
    //   type: String,
    //   default: 'primary'
    // }
    // title: {
    //   type: String,
    //   default: 'Title'
    // },
    // description: {
    //   type: String,
    //   default: 'Description'
    // }
  },
  data () {
    return {
      title: 'Are you sure?',
      description: '',
      variant: 'danger',
      isVisible: false,
      resolvePromise: null,
      rejectPromise: null
    }
  },
  computed: {
    remarkValue: {
      get () {
        return this.remark
      },

      set (val) {
        this.$emit('update-remark', val)
      }
    }
  },
  methods: {
    show ({ title, description, variant }) {
      this.title = title || 'Are you sure?'
      this.description = description
      this.variant = variant || 'danger'
      this.isVisible = true
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm () {
      this.isVisible = false
      this.resolvePromise(true)
    },

    _cancel () {
      this.isVisible = false
      this.resolvePromise(false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
